/**
 * Generated by orval v8.9.0 🍺
 * Do not edit manually.
 * PopulateEMR
 * OpenAPI spec version: v1
 */

export type ChargeSortingOption = typeof ChargeSortingOption[keyof typeof ChargeSortingOption];


export const ChargeSortingOption = {
  Default: 'Default',
  Code: 'Code',
  Description: 'Description',
  ChargeAmount: 'ChargeAmount',
} as const;
